import { useState, useCallback } from "react";
import axios from "axios";

export const useHttp = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const request = useCallback(async (url, method = "GET", data = null, headers = {}) => {
        setLoading(true);

        try {
            let response;

            if (method === "get") {
                response = await axios(url, data);
            } else {
                response = await axios({ method, url, data });
            }

            setLoading(false);
            return response;
        } catch (e) {
            console.log(e);
            setLoading(false);
            setError(e.response || "Неизвестная ошибка, попробуйте позже");
            throw e;
        }
    }, []);
    const clearError = () => setError(null);

    return { loading, request, error, clearError };
};
